<template>
    <div
        class="site-admin-page weeduc-admin-page global-site-weeduc adminWeeducSite text-start p-0"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    :title="$t('admin.site.title')"
                    :subtitle="pageSubtitle"
                    :hasMargin="false"
                />
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div
                class="weeduc-admin-page__panel"
                :class="{ 'weeduc-admin-page__panel--layout': isActiveTab(2) }"
            >
                <nav class="weeduc-admin-tabs" :aria-label="$t('admin.site.sectionsAria')">
                    <button
                        v-for="tab in siteTabs"
                        :key="tab.id"
                        type="button"
                        class="weeduc-admin-tab"
                        :class="{ 'weeduc-admin-tab--active': activeTab === tab.id }"
                        @click="setActiveTab(tab.id)"
                    >
                        {{ tab.label }}
                    </button>
                </nav>

                <div class="weeduc-admin-site-panels">
                    <section
                        v-show="isActiveTab(1)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(1) }"
                    >
                        <Config />
                    </section>

                    <section
                        v-show="isActiveTab(2)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(2) }"
                    >
                        <Content />
                    </section>

                    <section
                        v-show="isActiveTab(3)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(3) }"
                    >
                        <Domain />
                    </section>

                    <section
                        v-show="isActiveTab(4)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(4) }"
                    >
                        <Integration />
                    </section>

                    <section
                        v-show="isActiveTab(5)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(5) }"
                    >
                        <Advanced />
                    </section>

                    <section
                        v-if="!isCorporate"
                        v-show="isActiveTab(6)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(6) }"
                    >
                        <PortalStudent />
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Config from '@/components/Admin/Site/config'
    import Content from '@/components/Admin/Site/content'
    import Social from '@/components/Admin/Site/social'
    import Testimonials from '@/components/Admin/Site/testimonials'
    import Domain from '@/components/Admin/Site/domain'
    import Layout from '@/components/Admin/Site/layout'
    import Integration from '@/components/Admin/Site/integrations'
    import Advanced from '@/components/Admin/Site/advanced'
    import PortalStudent from '@/components/Admin/Site/portalStudent'
    import TitlePage from '@/components/Weflix/titlePage.vue'
    import { isCorporateEnvironment } from '@/utils/corporate/environment'

    export default {
        data() {
            return {
                activeTab: 1,
                hassaved: false,
                openmodalmodule: false,
            }
        },
        props: {
    
        },
        components: {
            Config,
            Content,
            Social,
            Testimonials,
            Domain,
            Layout,
            Integration,
            Advanced,
            PortalStudent,
            TitlePage,
        },
        computed: {
            isCorporate() {
                return isCorporateEnvironment();
            },
            siteTabs() {
                const tabs = [
                    { id: 1, label: this.$t('admin.site.basic') },
                    { id: 2, label: this.$t('admin.site.layout') },
                ];
                if (!this.isCorporate) {
                    tabs.push({ id: 6, label: this.$t('admin.site.portalStudent') });
                }
                tabs.push(
                    { id: 3, label: this.$t('admin.site.domain') },
                    { id: 4, label: this.$t('admin.site.integrations') },
                    { id: 5, label: this.$t('admin.site.advanced') },
                );
                return tabs;
            },
            pageSubtitle() {
                return this.isCorporate
                    ? this.$t('admin.site.subtitleCorporate')
                    : this.$t('admin.site.subtitleSchool');
            },
        },
        methods: {
            updatevalue(novoValor) {
                this.hassaved = novoValor;
            },
    
            setActiveTab(tabNumber) {
                this.activeTab = tabNumber;
            },
            isActiveTab(tabNumber) {
                return this.activeTab === tabNumber;
            },
            openmodal() {
                this.openmodalmodule = !this.openmodalmodule;
            },
            atualizarValorNoFilho(novoValor) {
                this.openmodalmodule = novoValor;
            }
        },
        created() {
            if (this.isCorporate && this.activeTab === 6) {
                this.activeTab = 1;
            }
        }
    }
</script>

<style scoped>
    @import url('@/css/weeduc/admin/dashboard-weflix-shell.css');

    .weeduc-admin-site-panels {
        min-height: 200px;
    }

    .weeduc-admin-page__panel--layout {
        padding: 0.65rem 0.75rem;
    }

    .weeduc-admin-page__panel--layout .weeduc-admin-tabs {
        margin-bottom: 0.5rem;
    }

    .weeduc-admin-site-section {
        display: block;
    }

    :global(.dashboard.dark) .weeduc-admin-page :deep(.v-btn.bg-primary) {
        background: #e8eaf0 !important;
        color: #1a1d24 !important;
    }

    @media (max-width: 500px) {
        .redes-sociais-mobile {
            min-width: fit-content !important;
        }
    }
</style>